import { Component, OnInit, Input, Renderer2, ElementRef, AfterViewInit } from '@angular/core';
import { TemplateSettingDialogService } from '../../template-setting-dialog.service';
import { SettingConfig, ActionType, FieldControl, FieldType } from '../../template-setting-dialog.model';
import { Subscription } from 'rxjs/Subscription';
import { OnDestroy } from '@angular/core';

@Component({
    selector: 'tam-template-base-layout',
    templateUrl: './template-base-layout.component.html',
    styleUrls: ['./template-base-layout.component.scss']
})
export class TemplateBaseLayoutComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() childConfig: any;
    isSelected = false;

    private _el: HTMLElement;
    private _ctrlName: string;
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _templateSettingService: TemplateSettingDialogService,
        private _renderer: Renderer2,
        private elementRef: ElementRef) { }

    ngOnInit() {
        this._el = this.elementRef.nativeElement;
        this._ctrlName = this.childConfig.config.controlName;
        this._destroySubscriptions.push(
            this._templateSettingService.actionSubject$.subscribe(item => this._settingTemplateConfig(item)));
    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
        this._destroySubscriptions = [];
    }

    clickControl(event, item?) {
        this._setStyle(0);
        this._templateSettingService.actionSubject$.next(new SettingConfig(ActionType.SELECT, new FieldControl(this.childConfig.config.controlName, this.childConfig.config.controlType), this.childConfig));
    }

    clickTrash(event, item?) {
        event.stopPropagation();
        this._templateSettingService.actionSubject$.next(new SettingConfig
            (ActionType.DELETE,
                new FieldControl(this.childConfig.config.controlName, this.childConfig.config.controlType),
                this.childConfig
            )
        );
    }

    private _setStyle(type) {
        // type 0 select 1 unselect
        switch (type) {
            case 0:
                this.isSelected = true;
                this._renderer.addClass(this._el.querySelector('.template-ctrl'), 'control-border');
                break;
            case 1:
                this.isSelected = false;
                this._renderer.removeClass(this._el.querySelector('.template-ctrl'), 'control-border');
                break;
            default:
                break;
        }
    }

    private _settingTemplateConfig(item: SettingConfig) {
        switch (item.action) {
            case ActionType.ADD:
                if (item.data.name === this.childConfig.config.controlName) {
                    this._setStyle(0);
                    this._templateSettingService.actionSubject$.next(new SettingConfig(ActionType.ADDCONFIG, new FieldControl(this.childConfig.config.controlName, this.childConfig.config.controlType), this.childConfig));
                    // this.clickControl('', item);
                } else {
                    this._setStyle(1);
                }
                break;
            case ActionType.SELECT:
                if (item.data.name !== this.childConfig.config.controlName) {
                    this._setStyle(1);
                } else {
                    this._setStyle(0);
                    // this.clickControl('', item);
                }
                break;
        }
    }
}
